import s from "styled-components";

export const Wrap = s.ul`
  margin-top: 20px;
  list-style-type: circle;
`;
export const Service = s.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 7px;
  padding-bottom: 5px;
  border-bottom: 1px dotted white;
`;
export const Price = s.div`
  margin-inline-start: 10px;
  flex-shrink: 0;
  text-align: right;
  strike {
    opacity: .4; 
  }
`;
export const ShowBtn = s.button`
  margin-top: 10px;
  display: flex;
  align-items: center;
  font-weight: 700;
  outline: none;
  span {
    margin-inline-start: 10px;
    border-bottom: 2px solid white;
    transition: border-color .25s ease;
  }
  :focus, :hover {
    span {
      border-color: transparent;
    }
  }
`;
